import { render, staticRenderFns } from "./EncuestaAsignar.vue?vue&type=template&id=73010111"
import script from "./EncuestaAsignar.vue?vue&type=script&lang=js"
export * from "./EncuestaAsignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports